"use client"
import React, { useRef } from "react"
import * as styles from "./logos.module.scss"
import { LogosType } from "./types"
import {
  Image,
  Title,
  useIntersectionObserver,
} from "@tfehotels/tfe-gatsby-library"

export default function Logos({ data, ...props }: LogosType) {
  const sectionRef = useRef(null)
  const [isVisible] = useIntersectionObserver(sectionRef, {
    threshold: 0.2,
  })

  return (
    <section
      className={`${styles.section} ${props.className ?? ""}`}
      ref={sectionRef}
    >
      <div className="padding-global">
        <div className="container">
          <div className="padding-section-large">
            <div
              className={`inner animate-position${isVisible ? " visible" : ""}`}
            >
              {!!data.title && <Title className="title" {...data.title} />}
              <ul>
                {data.images.map((img, k) => (
                  <li key={`logos${props.pk}-${k}`}>
                    {!!img.image && (
                      <Image
                        {...img}
                        style={{
                          width: (72 / img.image.height) * img.image.width,
                          height: 72,
                        }}
                      />
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
